export enum ConferenceAttendeeMembers {
  DIVERSE_INSIGHTS = "Diverse insights",
  NEW_FRAMEWORK_TOOLS = "New frameworks, tooling and tech",
  CASE_STUDIES_WORKSHOPS = "Case studies and workshops",
}
